export default {
  header: 'Neuložené zmeny',
  message: 'Tvoje zmeny sa stratia. Chceš to aj tak opustiť?',
};
